import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api, money } from "@/lib/api";
import { Reveal } from "@/components/Reveal";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  const categories = ["All", ...Array.from(new Set(products.map((p) => p.category)))];
  const shown = filter === "All" ? products : products.filter((p) => p.category === filter);

  return (
    <div data-testid="shop-page" className="pt-36 pb-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal>
          <p className="font-num uppercase tracking-[0.3em] text-primary text-sm mb-4">The Collection</p>
          <h1 className="font-display text-6xl md:text-8xl leading-[0.9] mb-10">Shop & Customize</h1>
        </Reveal>

        <div className="flex flex-wrap gap-3 mb-12 border-b border-white/10 pb-6">
          {categories.map((c) => (
            <button
              key={c}
              data-testid={`filter-${c.toLowerCase().replace(/\s/g, "-")}`}
              onClick={() => setFilter(c)}
              className={`btn-forge px-5 py-2 font-num uppercase tracking-widest text-xs border transition-colors ${
                filter === c
                  ? "bg-primary text-primary-foreground border-primary"
                  : "border-white/15 text-foreground/70 hover:border-primary hover:text-primary"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {shown.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.08}>
              <Link
                to={`/customize/${p.id}`}
                data-testid={`shop-product-${p.id}`}
                className="group block relative overflow-hidden border border-white/10 bg-[#0d0d0d]"
              >
                <div className="aspect-[4/5] overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.name}
                    className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-[transform,opacity] duration-700"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/10 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <span className="font-num uppercase tracking-widest text-[10px] text-primary">{p.category}</span>
                  <h3 className="font-display text-2xl mt-1">{p.name}</h3>
                  <p className="font-body text-sm text-muted-foreground mt-2">{p.blurb}</p>
                  <div className="mt-4 flex items-center justify-between">
                    <span className="font-num tracking-wide">from {money(p.base_price)}</span>
                    <span className="flex items-center gap-1 font-num uppercase text-xs tracking-widest text-primary">
                      Customize <ArrowUpRight className="w-4 h-4" />
                    </span>
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
